import React from 'react';
import styled from 'styled-components';
import Picker from 'emoji-picker-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import { AccountCircleOutlined } from '@material-ui/icons';

import EmojiIcon from '../../assets/icons/emoji.svg';
import { Send } from '../QPlayerSVGElement';
import { ChatNotice } from '../ChatUpdated/ChatUpdated.styled';
import { useChatLogin } from '../../contexts/ChatLoginContext';

const Container = styled.div`
	qplayer-embed .qplayer-app & {
		margin-bottom: 5px;
		width: 100%;
		display: flex;
		flex-direction: column;
		pointer-events: all;
		height: fit-content;
	}
`;

const ChatInputWrapper = styled.div`
	qplayer-embed .qplayer-app & {
		display: flex;
		flex-direction: row;
		height: 100%;
		width: 100%;
		background-color: #000000a5;
		opacity: 100%;
		position: relative;
		justify-content: center;
		align-items: center;
	}
`;

const ChatInput = styled.input`
	qplayer-embed .qplayer-app & {
		background: transparent !important;
		border: 1px solid #555555 !important;
		border-radius: 4px;
		color: white;
		width: 100%;
		padding: 2%;
		padding-left: 4%;
		font-size: 0.75em;
		font-family: inherit;
		-webkit-user-select: auto !important;
		user-select: auto !important;
		height: 40px;

		::placeholder {
			/* Chrome, Firefox, Opera, Safari 10.1+ */
			opacity: 1; /* Firefox */
		}

		:disabled {
			color: rgba(118, 118, 118, 0.3);
			border-color: rgba(118, 118, 118, 0.3);
		}
	}
`;

const EmojiIconStyled = styled.img`
	qplayer-embed .qplayer-app & {
		transform: scale(0.4);
		top: 50%;
		right: 10px;
		text-decoration: none;
		cursor: pointer;
		width: 40px;
	}
`;

const pickerStyle: React.CSSProperties = {
    position: 'absolute',
    left: '0px',
    bottom: '15%',
    display: 'block',
    width: '85%',
    height: '70%',
    zIndex: 999,
    overflow: 'hidden',
    background: 'rgba(0, 0, 0, 0.647)',
    borderRadius: '0',
    border: 'none',
    boxShadow: 'none',
    marginTop: '5px',
    outline: 'none',
};

interface ChatBottomProps {
    inputChatString: string;
    onChange: (_e: React.ChangeEvent<HTMLInputElement>) => void;
    handleMessagePost: (_e: any, _inputChatString: string) => void;
    handleFocusOnChatInput: () => void;
    emojiIconOnClick: () => void;
    emojiOnClick: (_event: any, _emojiObject: any) => void;
    showPicker: boolean;
    onEditProfileClick: () => void;
    disabledChatInput: boolean;
    isMobile: boolean;
}

const ChatBottom: React.FC<ChatBottomProps> = ({
    inputChatString,
    onChange,
    handleMessagePost,
    handleFocusOnChatInput,
    emojiIconOnClick,
    emojiOnClick,
    showPicker,
    onEditProfileClick,
    disabledChatInput,
    isMobile,
}) => {
    const { t } = useTranslation();
    const { username } = useChatLogin();

    return (
        <Container id="chatBottomId">
            <ChatNotice
                style={{
                    color: 'white',
                    paddingRight: '60px',
                }}
            >
                {inputChatString.trim().length}/300 {t('LABEL_CHARACTERS')}
            </ChatNotice>
            <ChatInputWrapper>
                <IconButton onClick={onEditProfileClick} title={t('PROFILE_SETTINGS')}>
                    <AccountCircleOutlined
                        htmlColor="#fff"
                        style={{
                            height: '18px',
                            width: '18px',
                        }}
                    />
                </IconButton>
                <ChatInput
                    id="chatInputFieldId"
                    type="text"
                    autoComplete="off"
                    maxLength={300}
                    placeholder={username ? `${t('SEND_MESSAGE_AS')}${username}` : t('WRITE_MESSAGE')}
                    data-meteor-emoji="true"
                    value={inputChatString}
                    onChange={onChange}
                    //TODO: need to fix clearing message after posting (possibly by moving state locally here)
                    onKeyUp={(e) => handleMessagePost(e, inputChatString)}
                    onFocus={() => handleFocusOnChatInput()}
                    disabled={disabledChatInput}
                />
                {!isMobile && <EmojiIconStyled src={EmojiIcon} onClick={emojiIconOnClick} />}
                {isMobile && (
                    <IconButton onClick={() => handleMessagePost({ keyCode: 13 }, inputChatString)} disabled={disabledChatInput}>
                        <Send color={disabledChatInput ? 'gray' : '#fff'} />
                    </IconButton>
                )}
            </ChatInputWrapper>
            {showPicker && !isMobile && (
                <Picker pickerStyle={pickerStyle as any} onEmojiClick={emojiOnClick} disableSearchBar disableAutoFocus disableSkinTonePicker preload />
            )}
        </Container>
    );
};

export { ChatBottom };
